module.exports = __webpack_public_path__ + "media/images/sections-73a66ada0402ba1f0e63f764f409e95f.png";